<script setup lang="ts">
import { defineProps } from "vue";

defineProps<{
  results: number[];
}>();
</script>

<template>
  <div class="flex flex-col-reverse items-center h-[66px]">
    <div
      v-for="(res, idx) in results"
      :key="results.length - idx - 1"
      class="mb-1 w-[70px] h-[7px]"
    >
      <img
        :src="
          require(`@/assets/calculators/iczin/${
            res === 6 || res === 8 ? 'double_line' : 'single_line'
          }.png`)
        "
        :alt="res === 6 || res === 8 ? 'Двойная линия' : 'Одиночная линия'"
        class="block w-[70px] h-[7px]"
      />
    </div>
  </div>
</template>
